
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { mainMenu } from '../../../../../data/header-main-menu';
import { MainMenuLink } from '../../../../interfaces/main-menu-link';
import { HeaderService } from '../../../../services/header.service';
import { ApiService} from '../../../../service/api.service'
import { Router } from '@angular/router';
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent{

    items: MainMenuLink[] = [];

    hoveredItem;
    @Input() show :boolean;

    @HostBinding('class.main-menu') classMainMenu = true;

    constructor(
        public header: HeaderService,
        public service : ApiService,
        public router : Router
    ) {
        // console.log(this.show)
        // if(this.show){
        //     this.items = [];
            this.service.getRegistrationType().subscribe((res:any) => {
                let i = 0;
                let len =  res.length
                for(i; i < len; i++){
                    let encodedName = encodeURI(`/listing-type/${res[i].slug}?category_id=${res[i].id}`);
                    this.items.push({ 'title' : res[i].name, 'url' : encodedName })
                }
            })




    }

    onItemEnter(item: any): void {
        this.hoveredItem = item;
    }

    onItemLeave(item: any): void {
        if ( this.hoveredItem === item ) {
            this.hoveredItem = null;
        }
    }

    onItemClick(data?): void {
        this.hoveredItem = null;
        console.log(data)
        if(data){
            this.router.navigateByUrl(data)
        }
    }
    navigate(url){
        console.log(url)
    }
}
